import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import backgroundImage from "../../images/slide2.png";
class Section extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
  }

  render() {
    return (
      <React.Fragment>
        <section
          className="section section-lg"
          id="home"
          style={{
            overflow : "hidden",
            height : window.innerHeight * .50 + "px",
            backgroundImage : `url(${backgroundImage})`,
            backgroundPosition: "center",
            backgroundRepeat: "no",
            backgroundSize: "cover",
          }}
        >
          <div className="bg-overlay h-100"> </div>
          <div className="display-table">
            <div className="display-table-cell">
              <Container>
                <Row>
                  <Col
                    lg={{ size: 8, offset: 2 }}
                    className="text-white text-center"
                  >
                    <h1 className="home-title text-rotate">
                      RediMD Privacy Policy and Practices
                    </h1>
                    <p 
                      className="pt-3"
                      style={{
                        fontWeight: 100,
                        fontSize: "24px",
                        lineHeight: "36px"
                      }}
                      >
                        This page explains how we use and protect your information
                    </p>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </section>
        <section className="mt-4 text-muted container">
          <p>
            This privacy policy ("policy") will help you understand how RediMD, LLC ("us", "we", "our") uses and protects the data you provide to us when you visit and use RediMD.com ("website", "service"). We reserve the right to change this policy at any given time, of which you will be promptly updated. If you want to make sure that you are up to date with the latest changes, we advise you to frequently visit this page.
          </p>
          <hr/>
          <h3>
              What User Data We Collect
          </h3>
          <p>                
              When you visit the website, we may collect the following data:
          </p>
          <ul class="realul">
              <li>
                  Your IP address.
              </li>
          </ul>
          <p>                
              If you choose to contact us we will collect:
          </p>
          <ul class="realul">
              <li>
                  Your contact information and email address.
              </li>
          </ul>
          <p></p>
          <h3>
              Why We Collect Your Data
          </h3>
          <p>                
              We are collecting your data for several reasons:
          </p>
          <ul class="realul">
              <li>
                  To better understand your needs.
              </li>
              <li>
                  To improve our services.
              </li>
              <li>
                  To measure the effectiveness of our marketing campaigns.
              </li>
          </ul>
          <p></p>
          <h3>
              Safeguarding and Securing the Data
          </h3>
          <p>                
              RediMD is HIPAA compliant and committed to securing your data and keeping it confidential. RediMD has done all in its power to prevent data theft, unauthorized access, and disclosure by implementing the latest technologies and software, which help us safeguard all the information we collect online.
          </p>
          <p></p>
          <h3>
              Our Cookie Policy
          </h3>
          <p>                
              Once you agree to allow our website to use cookies, you also agree to the use of the data it collects regarding your online behavior (analyze web traffic, web pages you spend the most time on, and websites you visit).  The data is only collected for the redimd.com servers.  We do not share your information outside of our organization in any way.  
              The data we collect by using cookies is used to provide functionality and to customize our website to your needs. After we use the data for statistical analysis, the data is completely removed from our systems. Please note that cookies don't allow us to gain control of your computer in any way. They are strictly used to monitor which pages you find useful and which you do not so that we can provide a better experience for you.
              If you want to disable cookies, you can do it by accessing the settings of your internet browser. 
          </p>
          <p></p>
          <h3>
              Links to Other Websites
          </h3>
          <p>                
              Our website contains links that lead to other websites. If you click on these links RediMD is not held responsible for your data and privacy protection. Visiting those websites is not governed by this privacy policy agreement. Make sure to read the privacy policy documentation of the website you go to from our website.
          </p>
          <p></p>
          <h3>
              Restricting the Collection of your Personal Data
          </h3>
          <p>                
              At some point, you might wish to restrict the use and collection of your personal data. You can achieve this by doing the following:
              When you are filling the forms on the website, make sure to check if there is a box which you can leave unchecked, if you don't want to disclose your personal information.
              If you have already agreed to share your information with us, feel free to contact us via email and we will be more than happy to change this for you.
              RediMD will not lease, sell or distribute your personal information to any third parties, unless we have your permission. We might do so if the law forces us. Your personal information will be used when we need to send you promotional materials if you agree to this privacy policy.
          </p>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
